import {
  Button,
  Dialog,
  Input,
  Form,
  Select,
  Checkbox,
  DatePicker,
  Message,
  Card,
  Table,
  Switch,
  NumberPicker,
  Calendar,
  List,
  CascaderSelect,
  Radio,
} from '@alifd/next';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { RangePicker } = DatePicker;
const Option = Select.Option;
const { Item } = Form;
const { Group: CheckboxGroup } = Checkbox;
const RadioGroup = Radio.Group;

const ContentList = (props) => {
  // console.log("=====props.filterKeys",props.filterKeys)
  const dateObj = {};

  const dd = new Date();
  const months =
    '一月,二月,三月,四月,五月,六月,七月,八月,九月,十月,十一月,十二月'.split(
      ','
    );
  const targetTable = client.service(props.tableName);
  const residentTable = client.service(props.residentTable);
  const [globalList, setGlobalList] = useState([]); // list Data Render
  // const [globalListAll, setGlobalListAll] = useState([]);//list Data All
  // const [filterKeys, setFilterKeys] = useState({});//過濾器 keys obj
  const [addCreateData, setAddCreateData] = useState({}); // Create send body
  const [patchObj, setPatchObj] = useState({}); // Patch Data
  const [editDialog, setEditDialog] = useState(false); // Dialog open control
  const [onChangeDate, setOnChangeDate] = useState([]); // onchange date

  const pdfExportComponent = useRef(null);

  if (!Object.prototype.hasOwnProperty.call(props, 'tableName'))
    return (
      <>
        <p>頁面錯誤!缺少必要參數</p>
      </>
    );

  function funCreate(sBody) {
    return new Promise((resolve, reject) => {
      try {
        const Res = targetTable.create(sBody);
        return resolve(Res);
      } catch (error) {
        return reject(error.message || error);
      }
    });
  }

  function funPatch(obj) {
    return new Promise((resolve, reject) => {
      try {
        const { _id } = obj;
        delete obj._id;
        const Res = targetTable.patch(_id, obj);
        return resolve(Res);
      } catch (error) {
        return reject(error.message || error);
      }
    });
  }

  function funAllPatch(para) {
    // 一鍵patch

    return new Promise((resolve, reject) => {
      try {
        para.forEach((element) => {
          const Res = targetTable.patch(element._id, element);
          return resolve(Res);
        });
        // const { _id } = obj;
        // delete obj._id;
      } catch (error) {
        return reject(error.message || error);
      }
    });
  }

  function funRemove(id) {
    return new Promise((resolve, reject) => {
      try {
        const Res = targetTable.remove(id);
        return resolve(Res);
      } catch (error) {
        return reject(error.message || error);
      }
    });
  }

  //   useEffect(() => {
  //     // 監聽 ListData 新增 > 重新渲染
  //     // console.log(props.dataList)
  //     setGlobalList([...props.dataList]);
  //     // setGlobalListAll([...props.dataList]);
  //     // setFilterKeys({});
  //   }, [props.dataList]);

  async function setObjValueByText(text, val) {
    // Edit Dialog set obj value
    const obj = {};
    obj[text] = val;
    if (text === 'household') {
      // 住戶連動區權人、聯絡電話
      const residentData = await residentTable.find({
        query: { householdNumber: val },
      });

      if (residentData.data && residentData.data.length === 1) {
        obj.userName = residentData.data[0].userName;
        obj.housePhone = residentData.data[0].housePhone;
      } else {
        console.log('===找不到區權人、聯絡電話，請選擇戶號');
        obj.userName = '';
        obj.housePhone = '';
      }
    }
    setPatchObj({ ...patchObj, ...obj });
  }

  function monthChangeNumSort(x) {
    // 排序月份
    if (x === '一月') {
      return 0;
    } else if (x === '二月') {
      return 1;
    } else if (x === '三月') {
      return 2;
    } else if (x === '四月') {
      return 3;
    } else if (x === '五月') {
      return 4;
    } else if (x === '六月') {
      return 5;
    } else if (x === '七月') {
      return 6;
    } else if (x === '八月') {
      return 7;
    } else if (x === '九月') {
      return 8;
    } else if (x === '十月') {
      return 9;
    } else if (x === '十一月') {
      return 10;
    } else if (x === '十二月') {
      return 11;
    }
  }
  const onTableSort = (dataIndex, order) => {
    // Sort

    setGlobalList(
      [...globalList].sort((a, b) => {
        if (a.month && b.month) {
          if (typeof monthChangeNumSort(a[dataIndex]) === 'number')
            return order === 'asc'
              ? monthChangeNumSort(a[dataIndex]) -
                  monthChangeNumSort(b[dataIndex])
              : monthChangeNumSort(b[dataIndex]) -
                  monthChangeNumSort(a[dataIndex]); // 是number排序
        }
        if (typeof a[dataIndex] === 'number')
          return order === 'asc'
            ? a[dataIndex] - b[dataIndex]
            : b[dataIndex] - a[dataIndex]; // 是number排序
        const result = a[dataIndex].localeCompare(
          typeof b[dataIndex] === 'number'
            ? b[dataIndex].toString()
            : b[dataIndex]
        ); // 是字串排序
        return order === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
      })
    );

    props.onChecked(
      [...globalList]
        .sort((a, b) => {
          if (a.month && b.month) {
            if (typeof monthChangeNumSort(a[dataIndex]) === 'number')
              return order === 'asc'
                ? monthChangeNumSort(a[dataIndex]) -
                    monthChangeNumSort(b[dataIndex])
                : monthChangeNumSort(b[dataIndex]) -
                    monthChangeNumSort(a[dataIndex]); // 是number排序
          }
          if (typeof a[dataIndex] === 'number')
            return order === 'asc'
              ? a[dataIndex] - b[dataIndex]
              : b[dataIndex] - a[dataIndex]; // 是number排序
          const result = a[dataIndex].localeCompare(
            typeof b[dataIndex] === 'number'
              ? b[dataIndex].toString()
              : b[dataIndex]
          ); // 是字串排序
          return order === 'asc' ? (result > 0 ? 1 : -1) : result > 0 ? -1 : 1;
        })
        .map((x) => {
          if (x.status === '已繳費') {
            return true;
          } else {
            return false;
          }
        })
    ); // 勾選全部改checkedData array
  };

  async function createPayData(oldData, check) {
    // 一鍵繳費
    console.log('oldData, check', oldData, check);
    const addData = [];
    const patchData = [];
    for (let i = 0; i < oldData.length; i++) {
      if (oldData[i].checked !== check[i]) {
        if (Object.prototype.hasOwnProperty.call(oldData[i], 'fakeData')) {
          // 有假資料新增Data
          oldData[i].status = '已繳費';
          oldData[i].targetDate = moment().format('YYYY-MM-DD');
          oldData[i].checked = true;
          delete oldData[i].fakeData;
          addData.push({ ...oldData[i] });
        } else {
          // 沒有假資料編輯Data
          // console.log("沒有假資料編輯Data")
          if (oldData[i].status === '已繳費') {
            // 判斷資料庫是否繳費
            oldData[i].status = '未繳費';
            oldData[i].targetDate = '';
            oldData[i].checked = false;
          } else {
            oldData[i].status = '已繳費';
            oldData[i].targetDate = moment().format('YYYY-MM-DD');
            oldData[i].checked = true;
          }
          patchData.push({ ...oldData[i] });
        }
      }
    }
    //    console.log("====patchData",patchData)
    //    console.log("====addData",addData)
    if (patchData && patchData.length > 0) {
      // 假資料新增跑這
      const PatchRes = await funAllPatch([...patchData]);
      props.onEdit(PatchRes, 'edit');
    }
    if (addData && addData.length > 0) {
      // 資料庫新增和編輯跑這
      const AddRes = await funCreate([...addData]);
      props.onEdit(AddRes, 'create');
    }
    Swal.fire('修改成功!', '該筆資料修改成功', 'success');
  }

  return (
    <div className={styles['filter-container']}>
      {
        // --渲染 filter Selector
        [...Object.keys(props.menuData)].map((e) => {
          if (e === 'month') {
            return (
              <Select
                // disabled={!!props.filterKeys.hasOwnProperty('targetDate')}
                hasClear
                mode="tag"
                placeholder={`選擇${props.menuData[e].text}`}
                dataSource={props.menuData[e].options}
                key={e}
                defaultValue={[props.menuData[e].defaultValue]}
                onChange={(value) => {
                  // filterBySelect(e, value);
                  // dateObj[ 'month' ] = value;
                  // dateObj.push({'month':value})

                  // setOnChangeDate(prev=>prev.push({'month':value}))
                  props.filterProps(value, e);
                }}
              />
            );
          } else if (e === 'year') {
            return (
              <Select
                hasClear
                // disabled={!!props.filterKeys.hasOwnProperty('targetDate')}
                placeholder={`選擇${props.menuData[e].text}`}
                dataSource={props.menuData[e].options}
                defaultValue={
                  props.menuData[e].defaultValue
                    ? props.menuData[e].defaultValue
                    : []
                }
                key={e}
                onChange={(value) => {
                  props.filterProps(value, e);
                }}
              />
            );
          } else if (e === 'householdNumber') {
            return (
              <CascaderSelect
                hasClear
                dataSource={props.householdNumbers}
                placeholder={`選擇${props.menuData[e].text}`}
                key={e}
                onChange={(value, data, extra) => {
                  // filterBySelect(e, value);
                  props.filterProps(value, e);
                }}
              />
            );
          } else if (e === 'status') {
            return (
              <Select
                hasClear
                // disabled={!!props.filterKeys.hasOwnProperty('targetDate')}
                placeholder={`選擇${props.menuData[e].text}`}
                dataSource={props.menuData[e].options}
                defaultValue={
                  props.menuData[e].defaultValue
                    ? props.menuData[e].defaultValue
                    : []
                }
                key={e}
                onChange={(value) => {
                  props.filterProps(value, e);
                }}
              />
            );
          } else {
            return '123';
          }
        })
      }
    </div>
  );
};

export default ContentList;
